import { FlowGraphBlock } from "../../flowGraphBlock.js";
import { RichTypeNumber } from "../../flowGraphRichTypes.js";
/**
 * A block that adds two numbers.
 * @experimental
 */
export class FlowGraphAddNumbersBlock extends FlowGraphBlock {
    constructor() {
        super();
        this.numberLeft = this._registerDataInput("numberLeft", RichTypeNumber);
        this.numberRight = this._registerDataInput("numberRight", RichTypeNumber);
        this.output = this._registerDataOutput("output", RichTypeNumber);
    }
    _updateOutputs(_context) {
        this.output.value = this.numberLeft.getValue(_context) + this.numberRight.getValue(_context);
    }
}
//# sourceMappingURL=flowGraphAddBlock.js.map